@if (summary().length) {
  <!-- A word's width apart, as if the summary were one line of text. -->
  <p class="mt-1 flex min-w-0 items-center gap-[0.25em] text-xs/[18px] text-neutral-500">
    @for (segment of summary(); track $index) {
      @switch (segment.type) {
        @case (SummarySegmentType.ARROW) {
          <i class="ph ph-arrow-right shrink-0"></i>
        }
        @case (SummarySegmentType.DOT) {
          <i class="ph ph-dot text-base/4"></i>
        }
        @case (SummarySegmentType.ID) {
          <span
            [pTooltip]="segment.text"
            [showDelay]="TOOLTIP_DEFAULT_DELAY"
            [showOnEllipsis]="true"
            class="max-w-20 truncate"
            tooltipPosition="top"
            tooltipStyleClass="text-xs"
            tooltipZIndex="2004"
          >
            {{ segment.text }}
          </span>
        }
        @default {
          <span>{{ segment.text }}</span>
        }
      }
    }
  </p>
}
